import http from "../utils/axios";
// 获取保单列表接口
export const getOrderList = data => {
  return http({
    url: "/api/order/getOrderList", // 接口
    method: "post",
    data: data
  });
};
// 获取订单详情接口
export const getOrderInfo = data => {
  return http({
    url: "/api/order/getOrderInfo", // 接口
    method: "post",
    data: data
  });
};
// 获取车险订单投、被保人接口
export const getCarOrderInsured = data => {
  return http({
    url: "/api/order/getCarOrderInsured", // 接口
    method: "post",
    data: data
  });
};
// 获取投保人信息接口
export const getOrderInsured = data => {
  return http({
    url: "/api/order/getOrderInsured", // 接口
    method: "post",
    data: data
  });
};
// 获取订单开票信息接口
export const getOrderInvoice = data => {
  return http({
    url: "/api/order/getOrderInvoice", // 接口
    method: "post",
    data: data
  });
};
// 获取保障人员列表接口
export const getOrderPersonnel = data => {
  return http({
    url: "/api/order/getOrderPersonnel", // 接口
    method: "post",
    data: data
  });
};
// 获取批改起保日期、是否可增加人员、可批改人员列表、基础保费（单价）接口
export const getCorrectionInfo = data => {
  return http({
    url: "/api/order/getCorrectionInfo", // 接口
    method: "post",
    data: data
  });
};
//申请批改接口
export const orderCorrection = data => {
  return http({
    url: "/api/order/orderCorrection", // 接口
    method: "post",
    data: data
  });
};
//取消保单接口
export const cancelOrder = data => {
  return http({
    url: "/api/order/cancelOrder", // 接口
    method: "post",
    data: data
  });
};
// 保单、批单操作记录接口
export const getOperationLog = data => {
  return http({
    url: "/api/order/getOperationLog", // 接口
    method: "post",
    data: data
  });
};
// 批改批量替换人员接口
export const getCorrectionPersonXls = data => {
  return http({
    url: "/api/order/getCorrectionPersonXls", // 接口
    method: "post",
    data: data
  });
};
// 美亚的退保接口
export const cancelPOrder = data => {
  return http({
    url: "/api/order/cancelPOrder", // 接口
    method: "post",
    data: data
  });
};
export const returnOrder = data => {
    return http({
      url: "/api/order/returnOrder", // 接口
      method: "post",
      data: data
    });
  };
